import React from 'react';
import PropTypes from 'prop-types';
import { imageSet } from '../../../helper/Images';
import { Image } from '../../../commonComponents';

const ImageDescription = ({ step }) => (
  <div className="tutorial-step-right py-2">
    <span className="tutorial-step-img">
      <Image
        className="img-responsive"
        src={imageSet[step.thumbnail]}
        alt="Tutorial Image"
      />
    </span>
    <span className="tutorial-step-desc">
      {step.description.map((item, index) => (
        <span className="tutorial-step-desc-item" key={index}>
          {item}
        </span>
      ))}
    </span>
  </div>
);

ImageDescription.propTypes = {
  step: PropTypes.object,
};

export default ImageDescription;
